/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Форма заказа
   */
  app.Order = app.Model.extend({
    
    urlRoot: app.entryScriptName + '/api/v3/order',
    
    settlementId: null,
    
    url: function () {
      var url = app.Model.prototype.url.apply(this, arguments),
        fragment = url.indexOf('?') === -1 ? '?' : '&';
      if (this.settlementId) {
        fragment += 'settlement_id=' + this.settlementId;
        url += fragment;
      }
      if (parseInt(this.get('deliveryTypeId')) === app.DELIVERY_TYPES.boxberry
        && this.get('userDeliveryAddress') && this.get('userDeliveryAddress').postal_code) {
        fragment = url.indexOf('?') === -1 ? '?' : '&';
        fragment += 'post_index=' + this.get('userDeliveryAddress').postal_code;
        url += fragment;
      }
      return url;
    },
    
    /**
     * Оформление дозаказа к заказу
     * @param id ID заказа к которому будет прикреплен текущий заказа
     * @param options Опции для сохранения
     * @returns {*}
     */
    reorder: function (id, options) {
      if (_.isNumber(id) && id > 0) {
        var errorCallback = options.error;
        options.error = function (model, response) {
          var errors;
          if (response.status === 422) {
            errors = JSON.parse(response.responseText);
            if (_.isArray(errors) && errors.length) {
              if (errorCallback && _.isFunction(errorCallback)) {
                errorCallback(errors);
              }
              app.helpers.ErrorHelper.globalValidationError(errors, 'При оформлении дозаказа');
            }
            return;
          }
          var errorMessage = 'При отправке запроса на оформление дозаказа произошла ошибка со статусом: '
            + response.status
            + ', в ответе пришло следующее: '
            + response.responseText;
          app.helpers.ErrorHelper.throwError(errorMessage);
        };
        var orderData = {
          re_ordering_id: id,
          type: 'user-order'
        };
        // Если переданы дополнительные данные, объединяем их с текущими
        if (options && options.newOrderData){
          _.extend(orderData, options.newOrderData);
        }
        return this.save(orderData, options);
      }
      return false;
    }
  });
  
  app.order = new app.Order();
})();

}.call(window));